import I18n from 'I18n';
// @ts-expect-error untyped file
import { updateMetaData } from 'FormsUI/actions/FormDefinition';
// @ts-expect-error untyped file
import { getFormGuid } from 'FormsUI/selectors/FormDefinition';
import fetchTranslatedFormLabels from 'FormsUI/api/FormTranslation/fetchTranslatedFormLabels';
import { getFormsLangToLang } from 'FormsUI/utils/Lang';
import Log from 'forms-utils-lib/logger/Logger';
const createAction = name => `@@translation/${name}`;
export const REQUEST_FORM_TRANSLATION = createAction('REQUEST_FORM_TRANSLATION');
export const SUCCEED_FORM_TRANSLATION = createAction('SUCCEED_FORM_TRANSLATION');
export const SUCCEED_FORM_TRANSLATION_NOTIFICATION = createAction('SUCCEED_FORM_TRANSLATION_NOTIFICATION');
export const FAIL_FORM_TRANSLATION = createAction('FAIL_FORM_TRANSLATION');
const requestFormTranslation = () => ({
  type: REQUEST_FORM_TRANSLATION
});
const succeedFormTranslation = payload => ({
  type: SUCCEED_FORM_TRANSLATION,
  payload
});
export const succeedFormTranslationNotification = () => ({
  type: SUCCEED_FORM_TRANSLATION_NOTIFICATION,
  meta: {
    notification: {
      type: 'success',
      title: I18n.text('formTranslateSuccess.title'),
      message: I18n.text(`formTranslateSuccess.title`)
    }
  }
});
export const failFormTranslation = error => ({
  type: FAIL_FORM_TRANSLATION,
  error,
  meta: {
    notification: {
      type: 'danger',
      titleText: I18n.text('formTranslateError.title'),
      message: I18n.text(`formTranslateError.message`)
    }
  }
});
export const translateForm = (formsLang, customOptions = {}) => (dispatch, getState) => {
  const state = getState();
  const options = Object.assign({
    formsLangToLang: true,
    notifyOnSuccess: false
  }, customOptions);
  const formGuid = getFormGuid(state);
  const newLang = options.formsLangToLang ? getFormsLangToLang(formsLang) : formsLang;
  dispatch(requestFormTranslation());
  return fetchTranslatedFormLabels(newLang, formGuid).then(value => {
    dispatch(succeedFormTranslation(value));
    dispatch(updateMetaData('lang', formsLang));
    if (options.notifyOnSuccess) {
      dispatch(succeedFormTranslationNotification());
    }
  }, error => {
    dispatch(failFormTranslation(error));
    Log.logServiceError('Failed to translate form', error);
  });
};
export default translateForm;